type GetCalculatedTipParams = {
  currentTip: number;
  amount: number;
  tipOptionsForLowDonation: number[];
  tipOptionsForHighDonation: number[];
  tipBreakpoint: number;
  previousAmount: number;
  defaultTipForAmountBelowBreakpoint: number;
  defaultTipForAmountAboveBreakpoint: number;
};

// if new options does not support current tip, value is changed to new min or nex max
// zero is supported but now mentioned in the options

export const getCalculatedTip = ({
  currentTip,
  amount,
  tipBreakpoint,
  tipOptionsForHighDonation,
  tipOptionsForLowDonation,
  previousAmount,
  defaultTipForAmountBelowBreakpoint,
  defaultTipForAmountAboveBreakpoint,
}: GetCalculatedTipParams): number => {
  if (!amount || isNaN(amount)) {
    return currentTip;
  }

  const tipOptions = amount > tipBreakpoint ? tipOptionsForHighDonation : tipOptionsForLowDonation;

  const highestPossibleTip = tipOptions[tipOptions.length - 1];
  const lowestPossibleTip = tipOptions[0];

  const isTipTooHigh = Number(amount) > tipBreakpoint && currentTip > highestPossibleTip;
  const isTipTooLow = Number(amount) <= tipBreakpoint && currentTip < lowestPossibleTip;
  const isTipSupported = tipOptions.includes(currentTip);

  const didAmountGoOverBreakpoint =
    Number.isFinite(previousAmount) && amount > tipBreakpoint && previousAmount <= tipBreakpoint;

  const didAmountGoBelowBreakpoint =
    Number.isFinite(previousAmount) && amount <= tipBreakpoint && previousAmount > tipBreakpoint;

  if (didAmountGoBelowBreakpoint) {
    return defaultTipForAmountBelowBreakpoint;
  }

  if (didAmountGoOverBreakpoint) {
    return defaultTipForAmountAboveBreakpoint;
  }

  if (currentTip === 0) {
    return currentTip;
  }

  if (isTipTooHigh) {
    return highestPossibleTip;
  }

  if (isTipTooLow) {
    return lowestPossibleTip;
  }

  if (!isTipSupported) {
    return 0;
  }

  return currentTip;
};
